<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '../store'
import { addDays, startOfLocalDay } from '../lib/tide'
import { springPhrase } from '../lib/springs'

const store = useAppStore()
const dayName = computed(() => {
  const d = new Date(store.selectedDay)
  const today = startOfLocalDay(Date.now())
  if (store.selectedDay === today) return `${store.t('today')}, ${d.toLocaleDateString(store.settings.locale, { day: 'numeric', month: 'long' })}`
  return d.toLocaleDateString(store.settings.locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
})
/** Taken at the middle of the day on show, as the old app took it at the middle of the span */
const springs = computed(() =>
  springPhrase(store.selectedDay + 12 * 3_600_000, store.station?.springLagDays, store.t, store.tv))

/**
 * A step that would leave the licensed range lands on its edge instead, and the buttons go
 * flat once there is nothing beyond it. An unregistered device holds a few days of data, so
 * walking past them would only show empty screens.
 */
function shift(days: number) { store.selectedDay = store.clampDay(addDays(store.selectedDay, days)) }
function today() { store.selectedDay = store.clampDay(startOfLocalDay(Date.now())) }
const atStart = computed(() => !store.dayAllowed(addDays(store.selectedDay, -1)))
const atEnd = computed(() => !store.dayAllowed(addDays(store.selectedDay, 1)))
/** Where the trial runs out, said once, next to the day it applies to */
const trial = computed(() => {
  const to = store.licence && !store.registered ? store.licence.to : null
  return to ? store.tv('demoUntil', new Date(to - 1).toLocaleDateString(store.settings.locale, { day: 'numeric', month: 'short' })) : ''
})
</script>

<template>
  <div class="dayname">{{ dayName }}<span class="springs">· {{ springs }}</span><span v-if="trial" class="springs trial">· {{ trial }}</span></div>
  <div class="datestrip">
    <button :disabled="atStart" @click="shift(-7)">{{ store.t('minusWeek') }}</button>
    <button :disabled="atStart" @click="shift(-1)">{{ store.t('minusDay') }}</button>
    <button class="today primary" @click="today">{{ store.t('today') }}</button>
    <button :disabled="atEnd" @click="shift(1)">{{ store.t('plusDay') }}</button>
    <button :disabled="atEnd" @click="shift(7)">{{ store.t('plusWeek') }}</button>
  </div>
</template>
